// extracted by mini-css-extract-plugin
export default {"top":"International_top__z4yL3","back_btn":"International_back_btn__CmFH3","bottom":"International_bottom__v7j1W"};